import { createRouter, createWebHistory } from 'vue-router';
import FirmRegister from '../components/PublicArea/FirmRegister.vue';
import UserRegister from '../components/PublicArea/UserRegister.vue';
import UserRegisterConfirmation from '../components/PublicArea/UserRegisterConfirmation.vue';
import Offer from '../components/PrivateArea/Offer.vue';
import Applicant from '../components/PrivateArea/Offer/Applicant.vue';
import BaseConditions from '../components/PrivateArea/Offer/BaseConditions.vue';
import CheckList from '../components/PrivateArea/Offer/CheckList.vue';
import CustomerIncome from '../components/PrivateArea/Offer/CustomerIncome.vue';
import PartnerIncome from '../components/PrivateArea/Offer/PartnerIncome.vue';
import CustomerExpenses from '../components/PrivateArea/Offer/CustomerExpenses.vue';
import PrivacyConsent from '../components/PrivateArea/Offer/PrivacyConsent.vue';
import UserPrivacyConsent from '../components/PrivateArea/UserPrivacyConsent.vue';
import DashboardDetailMain from '../components/PrivateArea/Dashboard/DashboardDetailMain.vue';
import CustomerConfirmation from '../components/PrivateArea/Offer/CustomerConfirmation.vue';
import CustomerRejection from '../components/PrivateArea/Offer/CustomerRejection.vue';
const Tests = () => import ('../components/Tests.vue');
const Dashboard = () => import ('../components/PrivateArea/Dashboard/Dashboard.vue');
const UserSettings = () => import ('../components/PrivateArea/UserSettings.vue');
const Tickets = () => import ('../components/PrivateArea/Tickets/Tickets.vue');
const Requests = () => import ('../components/PrivateArea/Offer/Requests.vue');
import NotFound from '../components/NotFound.vue';

import useUtils from '../components/hooks/useUtils';
const { sleep } = useUtils();

const routes = [
	{
		path: "",
		text: 'Startseite',
		iconCss: 'icon icon-home',
		redirect: {
			name: 'Dashboard'
		},
		meta: {
			requiresAuth: false,
		}
	},
	/** Main menu */
	{
		path: "/offer",
		text: '',
		key: 'eny.get_offer',
		name: 'offer',
		iconCss: 'icon icon-handshake',
		type: "Mainmenu",
		components: {
			public: Offer,
			default: Offer,
		},
		meta: {
			requiresAuth: false,
		},
	},
	/** Starting offer for admin user */
	{
		path: "/offer/firm/enyFinance",
		text: '',
		key: 'eny.get_offer',
		name: 'offer_eny',
		iconCss: 'icon icon-handshake',
		type: "Mainmenu",
		components: {
			public: Offer,
			default: Offer,
		},
		meta: {
			requiresAuth: false,
			firmName: 'enyFinance',
		}
	},
	/** V3: starting offer from the link  */
	{
		path: "/offer/firm/:firm",
		text: '',
		key: 'eny.get_offer_with_firm',
		name: 'offer_firm',
		iconCss: 'icon icon-handshake',
		components: {
			public: Offer,
			default: Offer,
		},
		meta: {
			requiresAuth: false,
		}
	},
	/** Check list */
	{
		path: "/offer/checklist",
		text: 'offer_checklist',
		components: {
			public: CheckList,
			default: CheckList
		},
		meta: {
			requiresAuth: false,
		}
	},
	/** Offer sub menus */
	{
		path: "/offer/applicant",
		text: 'offer_applicant',
		components: {
			public: Applicant,
			default: Applicant
		},
		meta: {
			requiresAuth: false,
		}
	},
	{
		path: "/offer/applicant/firm/:firm/amount/:amount/duration/:duration/insurance/:insurance",
		text: 'offer_applicant_with_params',
		components: {
			public: Applicant,
			default: Applicant
		},
		meta: {
			requiresAuth: false,
		}
	},
	{
		path: "/offer/basecond",
		text: 'offer_base_conditionas',
		components: {
			public: BaseConditions,
			default: BaseConditions
		},
		meta: {
			requiresAuth: false,
		}
	},
	{
		path: "/public/offer/basecond/:uid",
		text: 'offer_base_conditionas',
		components: {
			public: BaseConditions,
			default: NotFound
		},
		type: "PublicOffer",
		meta: {
			requiresAuth: false,
		}
	},
	{
		path: "/offer/confirmation/:uid?",
		text: 'offer_confirmation',
		components: {
			public: CustomerConfirmation,
			default: CustomerConfirmation
		},
		meta: {
			requiresAuth: false,
		}
	},
	{
		path: "/offer/rejection",
		text: 'offer_rejection',
		components: {
			public: CustomerRejection,
			default: CustomerRejection
		},
		meta: {
			requiresAuth: false,
		}
	},
	{
		path: "/offer/customer_income",
		text: 'offer_customer_income',
		components: {
			public: CustomerIncome,
			default: CustomerIncome
		},
		meta: {
			requiresAuth: false,
		}
	},
	{
		path: "/offer/customer_partner_income",
		text: 'offer_customer_partner_income',
		components: {
			public: PartnerIncome,
			default: PartnerIncome
		},
		meta: {
			requiresAuth: false,
		}
	},
	{
		path: "/offer/customer_expenses",
		text: 'offer_customer_expenses',
		components: {
			public: CustomerExpenses,
			default: CustomerExpenses
		},
		meta: {
			requiresAuth: false,
		}
	},
	{
		path: "/offer/privacy_consent",
		text: 'offer_privacy_consent',
		components: {
			public: PrivacyConsent,
			default: PrivacyConsent
		},
		meta: {
			requiresAuth: false,
		}
	},
	{
		path: "/public/offer/privacy_consent/:uid",
		text: 'offer_privacy_consent',
		components: {
			public: PrivacyConsent,
			default: NotFound
		},
		meta: {
			requiresAuth: false,
		}
	},
	{
		path: "/dashboard",
		text: '',
		key: 'eny.dashboard',
		name: 'Dashboard',
		iconCss: 'icon icon-dashboard',
		component: Dashboard,
		type: "Mainmenu",
		meta: {
			requiresAuth: true,
		}
	},
	{
		path: "/dashboard_data/:uid",
		text: 'Dashboard_Data',
		name: 'DashboardDetail',
		component: DashboardDetailMain,
		meta: {
			requiresAuth: true,
			adminOnly: true,
			redirectTo: "/dashboard",
		}
	},
	{
		path: "/tickets",
		text: '',
		key: 'eny.tickets',
		iconCss: 'icon icon-message',
		component: Tickets,
		type: "Mainmenu",
		meta: {
			requiresAuth: true,
		}
	},
	{
		path: "/requests",
		text: '',
		key: 'eny.requests',
		name: 'requests',
		iconCss: 'icon icon-list',
		component: Requests,
		type: "Mainmenu",
		meta: {
			requiresAuth: true,
		}
	},
	{
		path: "/tests",
		text: '',
		key: 'eny.tests',
		name: 'tests',
		iconCss: 'icon icon-mail',
		component: Tests,
		type: "Mainmenu",
		meta: {
			requiresAuth: true,
		}
	},
	{
		path: "/privacy_consent",
		name: "UserPrivacyConsent",
		text: 'privacy_consent',
		component: UserPrivacyConsent,
		meta: {
			requiresAuth: true,
		}
	},
	{
		type: "Separator",
	},
	/** Settings menu */
	{
		path: "/settings",
		text: '',
		key: 'eny.settings',
		iconCss: 'icon icon-settings',
		component: UserSettings,
		type: "Settings",
		meta: {
			requiresAuth: true,
		}
	},
	{
		path: "/logout",
		text: '',
		key: 'eny.logout',
		name: 'logout',
		iconCss: 'icon icon-log-out',
		component: { template: '<div class="">Logout</div>' },
		type: "Settings",
		meta: {
			requiresAuth: true,
		}
	},
	/** Register, public area */
	{
		path: "/register",
		name: 'register',
		components: {
			public: FirmRegister,
			default: FirmRegister
		},
		type: "Registration",
		meta: {
			requiresAuth: false,
		},
	},
	{
		path: "/registerDetails/:firmname/uid/:uid",
		name: 'userRegister',
		components: {
			public: UserRegister,
			default: UserRegister
		},
		type: "Registration",
		meta: {
			requiresAuth: false,
		}
	},
	{
		path: "/registerConfirmation/",
		name: 'UserRegisterConfirmation',
		components: {
			public: UserRegisterConfirmation,
			default: UserRegisterConfirmation
		},
		type: "Registration",
		meta: {
			requiresAuth: false,
		}
	},
	/** Fallback / Not found */
	{
		path: "/:catchAll(.*)",
		text: "WrongPath",
		components: {
			public: UserRegister,
			default: NotFound
		},
		meta: {
			requiresAuth: false
		}
	},
];

const router = createRouter({
	history: createWebHistory(),
	routes: routes,
});

// Redirect user to home page, if he is a guest and trying to access a page, which has userOnly=true
router.beforeEach(async(to, from, next) => {
	/*console.log("to=");
	console.log(to);
	console.log("from=");
	console.log(from); */
	if (to.matched.some(rec => rec.meta.requiresAuth)) {
		const kc=router.app.config.globalProperties.$keycloak;
		// We wait for Keycloak init, then we can call all methods safely
		while (kc.createLoginUrl === null) {
			await sleep(10);
		}
		if (kc.authenticated) {
			//if the route for admins only and the current user isn't an admin, redirect him to a page, defined in the redirectTo tag
			if (to.meta.adminOnly && !kc.hasRealmRole('admin')) {
				router.push(to.meta.redirectTo);
			}
			next();
		}
		else {
			const loginUrl = kc.createLoginUrl();
			window.location.replace(loginUrl);
			next();
		}
	}
	else if (to.path != '' || from.path == '') {
		next();
	}
});
export default router;
